import { HTMLUtils } from '../../../../utils/html.utils';
import { AbstractEditTool } from './abstract-edit-tool';
import { CCanvas } from './ccanvas';
import { ImageContainer } from './image-container';
import { Photo } from './photo';

export class Rotate extends AbstractEditTool {
    photoModel: Photo;
    angleInDegrees = 0;

    constructor(photoModel: Photo, container: ImageContainer, private styles: any) {
        super(container);
        this.photoModel = photoModel;
    }

    public async load(): Promise<void> {
        HTMLUtils.addClass(this.photoModel.getEphemeralCanvas(), 'relative', this.styles.relative);
        this.handleResizeEvent();
    }

    private notifyChanges(): void {
        const changed = this.angleInDegrees != 0
        this.notifyHasChanges(changed);
    }

    public async rotateClockWise() {
        this.angleInDegrees = (this.angleInDegrees + 90) % 360;
        this.drawImage();
        this.notifyChanges();
    }

    public async rotateCounterClockWise() {
        this.angleInDegrees = ((this.angleInDegrees - 90) % 360 + 360) % 360;
        this.drawImage();
        this.notifyChanges();
    }

    private drawImage() {
        this.container.showWithSpinner(() => {
            CCanvas.rotate(this.photoModel.getPersistedCanvas(), this.photoModel.getEphemeralCanvas(), this.angleInDegrees);
            this.handleResizeEvent();
        });
        // this.photoModel.getCarmanCanvas().width = this.photoModel.getEphemeralCanvas().width;
        // this.photoModel.getCarmanCanvas().height = this.photoModel.getEphemeralCanvas().height;
        // CCanvas.applyFilter(this.photoModel.getCarmanCanvas(), FilterConfig.getCurrentFilterConfig(), this.photoModel.getEphemeralCanvas());
    }

    public handleResizeEvent() {
        this.getContainer().bestFitContainerAndCanvas();
    }

    public async updateYImage(): Promise<HTMLImageElement> {
        if (this.angleInDegrees % 360 !== 0) {
            CCanvas.rotate2(this.photoModel.getPersistedCanvas(), this.angleInDegrees);
            CCanvas.copyCanvas(this.photoModel.getPersistedCanvas(), this.photoModel.getEphemeralCanvas());
            // Clear scale since download may call this method through finalize again
            this.angleInDegrees = 0;
        }
        return null;
    }

    public async finalize() {
        await this.updateYImage();
    }
}

